import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { useState, useEffect } from "react";
import useSnackbar from "../../../hooks/useSnackbar";
import AgGridPaginatedTable from "../../../components/AgGridPaginatedTable";
import {
  revArrRevenueElementTable,
  revArrAllocationDetailTable,
  revArrRevenueArrangementVersionTable,
  revArrRevenueArrangementMessageTable,
} from "../../../config/grid-column-defs";
import {
  getTransactionRevArrangAllocation,
  getTransactionRevArrangRevenueElement,
  getTransactionRevArrangMessage,
  getTransactionRevArrangVersion,
} from "../../../api/transaction-type";

import { slugMap } from "../../../config/slug-config";
import { Link, useNavigate, useParams } from "react-router-dom";
import { Box, Grid, CircularProgress, Tabs, Tab, Button } from "@mui/material";
import TabPanel from "../../../components/TabPanel";
import { CustomCheckBoxComp126 } from "../../../components/CheckboxComp";
import RevenueRecognitionPlanViewDialog from "./revenue-recognition-plan-Dialog";

import {
  Download,
  SquareFootOutlined,
  SquareOutlined,
} from "@mui/icons-material";

export default function RevenueArrangementRevenueElements() {
  const snackbar = useSnackbar();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const dialogAction = useSelector((state) => state.dialog);
  const { data: user } = useSelector((state) => state.user);
  const params = useParams();
  const [tabIndex, setTabIndex] = useState(0);
  const pageDetail = slugMap[params.slug];
  const [residual, setResidual] = useState("");
  const [openDialog, setOpenDailog] = useState(false);
  const [fairValueFormula, setFVF] = useState("");
  const [itemId, setItemId] = useState("");
  //  const [tableRefreshCount, setTableRefreshCount] = useState(0);
  //  function refreshTable () {
  //      setTableRefreshCount(prev => prev + 1);
  //  }
  let obj = revArrRevenueElementTable.find(
    (o) => o.headerName === "REVENUE RECOGNITION PLAN"
  );

  addAdditionalColumn(obj, dispatch);
  useEffect(() => {
    if (user.token && tabIndex === 1) {
      getTransactionRevArrangAllocationData();
    }
  }, []);

  async function getTransactionRevArrangAllocationData(limit, offset) {
    try {
      const { data } = await getTransactionRevArrangAllocation(user.token, {
        id: params.docNo,
        limit,
        offset,
      });
      setResidual(data.data.residual);
      return { rows: data.data.data, total: data.data.total, error: false };
    } catch (error) {
      console.log(error);
      snackbar.showError("Error In Loading Data.");
      return { error: true };
    } finally {
      // setLoading(false);
    }
  }

  async function getTransactionRevArrangRevenueElementData(limit, offset) {
    try {
      const { data } = await getTransactionRevArrangRevenueElement(user.token, {
        id: params.docNo,
        limit,
        offset,
      });
      return { rows: data.data.items, total: data.data.itemstotal, error: false };
    } catch (error) {
      console.log(error);
      snackbar.showError("Error In Loading Data.");
      return { error: true };
    } finally {
      // setLoading(false);
    }
  }

  async function getTransactionRevArrangMessageData(limit, offset) {
    try {
      const { data } = await getTransactionRevArrangMessage(user.token, {
        id: params.docNo,
        limit,
        offset,
      });
      return { rows: data.data.data, total: data.data.total, error: false };
    } catch (error) {
      // console.log(error);
      // snackbar.showError("Error In Loading Data.");
      return { error: true };
    } finally {
      // setLoading(false);
    }
  }

  async function getTransactionRevArrangVersionData(limit, offset) {
    try {
      const { data } = await getTransactionRevArrangVersion(user.token, {
        id: params.docNo,
        limit,
        offset,
      });
      return { rows: data.data.data, total: data.data.total, error: false };
    } catch (error) {
      // console.log(error);
      // snackbar.showError("Error In Loading Data.");
      return { error: true };
    } finally {
      // setLoading(false);
    }
  }
  useEffect(() => {
    if (!dialogAction.type) return;
    switch (dialogAction.type) {
      case "DIALOGVIEW":
        dispatch({ type: "" });
        setItemId(dialogAction?.data?.item_id);
        setOpenDailog(true);
        break;
      case "FAIRVALUEFORMULAVIEW":
        dispatch({ type: "" });
        console.log("diallll", dialogAction.data.fair_value_formula);
        navigate(`fair-value-formula/${dialogAction.data.fair_value_formula}`);
        break;

      default:
        break;
    }
  }, [dialogAction]);
  return (
    <>
      <Tabs
        value={tabIndex}
        // onChange={handleChange}
        onChange={(e, nv) => {
          setTabIndex(nv);
        }}
        variant="scrollable"
        scrollButtons="auto"
        aria-label="scrollable auto tabs example"
        className="tabs-bkg1 tabs-spacing"
      >
        <Tab label="Revenue Element" />
        <Tab label="Allocation Detail" />
        <Tab label="Revenue Arrangement Version" />
        <Tab label="Revenue Arrangement Message" />
      </Tabs>

      {/* Revenue Element */}
      <TabPanel value={tabIndex} index={0}>
        {tabIndex === 0 ? (
          <AgGridPaginatedTable
            getTableRows={getTransactionRevArrangRevenueElementData}
            columns={revArrRevenueElementTable}
            perPage={5}
            refreshCounter={0}
          />
        ) : (
          <></>
        )}
      </TabPanel>
      {/* Revenue Element */}

      {/* Allocation Detail */}
      <TabPanel value={tabIndex} index={1}>
        <Box className="viewDetilsBox">
          <Grid container>
            <CustomCheckBoxComp126 title={"RESIDUAL"} data={residual} />
          </Grid>
        </Box>
        {tabIndex === 1 ? (
          <AgGridPaginatedTable
            getTableRows={getTransactionRevArrangAllocationData}
            columns={revArrAllocationDetailTable}
            perPage={5}
            refreshCounter={0}
          />
        ) : (
          <></>
        )}
      </TabPanel>
      {/* Allocation Detail */}

      {/* Revenue Arrangement Version */}
      <TabPanel value={tabIndex} index={2}>
        {tabIndex === 2 ? (
          <AgGridPaginatedTable
            getTableRows={getTransactionRevArrangVersionData}
            columns={revArrRevenueArrangementVersionTable}
            perPage={5}
            refreshCounter={0}
          />
        ) : (
          <></>
        )}
      </TabPanel>
      {/* Revenue Arrangement Version */}

      {/* Revenue Arrangement Message */}
      <TabPanel value={tabIndex} index={3}>
        {tabIndex === 3 ? (
          <AgGridPaginatedTable
            getTableRows={getTransactionRevArrangMessageData}
            columns={revArrRevenueArrangementMessageTable}
            perPage={5}
            refreshCounter={0}
          />
        ) : (
          <></>
        )}
      </TabPanel>
      {/* Revenue Arrangement Message */}
      <RevenueRecognitionPlanViewDialog
        open={openDialog}
        itemId={itemId}
        handleClose={setOpenDailog}
      />
    </>
  );
}
function addAdditionalColumn(obj, dispatch) {
  if (obj === undefined) {
    revArrRevenueElementTable.push({
      headerName: "REVENUE RECOGNITION PLAN",
      field: "revenue_recognition_plan",
      minWidth: 220,
      cellClass: "downloadCenter",
      cellRendererFramework: (params) => (
        <Box>
          {params.value ? (
            <Button
              title="REVENUE RECOGNITION PLAN"
              className="actionIcon"
              onClick={() => {
                dispatch({
                  type: "DIALOGVIEW",
                  data: params.data,
                });
              }}
            >
              <Link to={``} className="ag-cell-view-button">
                {params?.value}
              </Link>
            </Button>
          ) : (
            <></>
          )}
        </Box>
      ),
    });
    revArrAllocationDetailTable.push({
      headerName: "FAIR VALUE FORMULA",
      field: "fair_value_formula",
      minWidth: 220,
      cellClass: "downloadCenter",
      cellRendererFramework: (params) => (
        <Box>
          {params.value ? (
            <Button
              title="Fair Value Formula"
              className="actionIcon"
              onClick={() => {
                dispatch({
                  type: "FAIRVALUEFORMULAVIEW",
                  data: params.data,
                });
              }}
            >
              <Link to={``} className="ag-cell-view-button">
                {params?.value}
              </Link>
            </Button>
          ) : (
            <></>
          )}
        </Box>
      ),
    });
  }
}
